import styled from 'styled-components';

export const InfoToggleLink = styled.a`
	font-size: ${({ fontSize }) => fontSize || '1rem'};
	font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
	color: ${({ theme }) => theme.colors.textSecondary};
	text-decoration: none;
	cursor: pointer;
	display: inline-block;

	&:hover {
		text-decoration: none;
	}

	> div {
		vertical-align: sub;
	}

	svg {
		transition: transform 0.25s ease-out;
		transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : null)};
	}
`;

export const InfoToggleContent = styled.div`
	font-size: ${({ fontSize }) => fontSize || '1rem'};
	padding-top: 1em;
`;
